import React from 'react'
import '../shopContact.scss'
import alifShopLogo from '../../../../shared/assets/images/partnerDetails/alifshop-logo.svg'

export const AlifshopLink = (props) => {
    return (
        < div className="alif-shop-card">
            <div className="alif-shop-card-head">
                <p className="alif-shop-card-title">Товары этого магазина можно купить через онлайн-магазин alif.shop</p>
                <img src={alifShopLogo} alt="alifshop-logo" />
            </div>
            <a className="alif-shop-card-link" href={`https://alifshop.tj/shops/${props.alifshopLink}`}>Перейти в онлайн-магазин</a>
        </div>
    )
}
